import type { SxProps, Theme } from '@mui/material'

export const styles = {
  emptyRoot: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    paddingTop: 1,
    paddingBottom: 2,
    paddingX: 2,
    width: '100%',
    minHeight: '100%',
  },
  // Stable wrapper around the success-path children. Real layout (flex
  // column) so html2canvas has a non-zero bounding rect to rasterise.
  // `flex: 1; min-height: 0` lets nested scroll regions / fixed-height
  // chart canvases size correctly inside Widget.Content's flex column.
  captureBox: {
    width: '100%',
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
} satisfies Record<string, SxProps<Theme>>
